import { FormGroup } from './';
import lockable from '../../hoc/lockable';

export default lockable(FormGroup);